import axiosInstance from "../../axiosInstance";

const BASE_URL = "/finance/advance-requests";

// ===========================
// 🔹 Lấy danh sách
// ===========================
export const getAllAdvanceRequests = async () => {
  const res = await axiosInstance.get(BASE_URL);
  return res.data.records;
};

// ===========================
// 🔹 Lấy chi tiết
// ===========================
export const getAdvanceDetail = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

// ===========================
// 🔹 Tạo mới (JSON hoặc FormData kèm PDF)
// ===========================
export const createAdvanceRequest = async (data) => {
  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;
  const res = await axiosInstance.post(BASE_URL, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    timeout: isFormData ? 120_000 : 30_000,
  });
  return res.data;
};

// ===========================
// 🔹 Gửi duyệt (Nháp → Chờ duyệt)
// ===========================
export const submitAdvanceRequest = async (id, data = {}) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/submit`, data);
  return res.data;
};

export const getAdvanceApproverCandidates = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/meta/approver-candidates`, {
    params,
  });
  return res.data;
};

// ===========================
// 🔹 Cập nhật
// ===========================
export const updateAdvanceRequest = async (id, data) => {
  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;
  const res = await axiosInstance.put(`${BASE_URL}/${id}`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    timeout: isFormData ? 120_000 : 30_000,
  });
  return res.data;
};

// ===========================
// 🔹 APPROVE
// ===========================
export const approveAdvance = async (id, data = {}) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}/approve`, data);
  return res.data;
};

// ===========================
// 🔹 REJECT
// ===========================
export const rejectAdvance = async (id, reject_reason) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}/reject`, {
    reject_reason,
  });
  return res.data;
};

export const remindAdvanceApprovers = async (id) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/remind`);
  return res.data;
};

// ===========================
// 🔹 Quyết toán
// ===========================
export const settleAdvance = async (id, data) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/settlement`, data);
  return res.data;
};

// ===========================
// 🔹 Xóa
// ===========================
export const deleteAdvanceRequest = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};

export const getAdvanceApprovalRules = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/meta/approval-rules`, {
    params,
  });
  return res.data;
};

export const createAdvanceApprovalRule = async (data) => {
  const res = await axiosInstance.post(`${BASE_URL}/meta/approval-rules`, data);
  return res.data;
};

export const updateAdvanceApprovalRule = async (id, data) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/meta/approval-rules/${id}`,
    data
  );
  return res.data;
};

export const deleteAdvanceApprovalRule = async (id) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/meta/approval-rules/${id}`
  );
  return res.data;
};
